<template>
  <div class="about">
    <div class="about-top">
      <div v-if="!isMobile" class="animated fadeInDown slow">
        <div style="font-size: 24px">关于我们</div>
        <div style="font-size: 14px; padding: 20px">丈量，不可估量的未来</div>
        <div>
          中智贵阳人力资本科技有限公司运营的赛码网（ACMcoder），是由中智国际人才资源服务有限公司孵化，运用跨界思维
        </div>
        <div>将大赛技术应用于解决IT人才技能甄选的在线考试训练平台。</div>
        <div>
          作为IT技能评定行业的领跑者，近年来为众多国内外知名互联网企业的校园人才选拔测评提供了重要支撑
        </div>
        <div>
          通过海量能力测试大数据的积累，逐步建立了人才能力评测的大数据中心。
        </div>
        <div>
          赛码网已经成功服务阿里巴巴、京东、字节跳动、美团、滴滴、小米、网易、搜狗、携程、华为、大疆创新、科大讯飞、360、学而思网校等
        </div>
        <div>
          众多一线互联网及智能制造企业在线IT编程考试，共完成千万人次的人才甄别服务，汇聚上百万的IT精英人才。
        </div>
        <div style="padding-top: 20px">
          赛码网通过智能在线考试面试平台，助力企业轻松完成人才甄选，降低人才选拔成本，加速传统人才服务的智能化转型。
        </div>
        <div>
          目前已在互联网、金融、教育、零售、制造、医疗、能源等领域成功落地上万个在线考试面试应用，连续多年获得各种奖项。
        </div>
      </div>
      <div v-if="isMobile" class="animated fadeInDown slow">
        <div style="font-size: 24px; padding-top: 20px">关于我们</div>
        <div style="font-size: 14px; padding: 20px">丈量，不可估量的未来</div>
        <div>赛码网(ACMcoder)</div>
        <div>由中智贵阳人力资本科技有限公司运营，</div>
        <div>由中智国际人才资源服务有限公司孵化，</div>
        <div>是运用跨界思维，将大赛技术应用于解决</div>
        <div>IT人才甄法问题的在线考试训练平台。</div>
        <div>依托Online Judge在线判题系统(简称O.J),</div>
        <div>赛码网作为IT技能考试服务行业的领跑者，</div>
        <div>始终活跃在众多国内外知名互联网企业的</div>
        <div>校园招聘过程中。完美地解决IT类考试</div>
        <div>特别是编程题考试中从出题，到阅卷</div>
        <div>以及如何严防作弊等一系列图扰企业HR的问题，</div>
        <div>更好的助力企业快速、准确的锁定合适的IT人才。</div>
      </div>
      <about-top-cell class="animated fadeInUp slow" />
    </div>
    <div class="about-middle">
      <div class="about-middle-up">
        <div class="about-middle-up-pic"></div>
        <div class="about-middle-up-content">
          <div class="content-title">团队介绍</div>
          <div class="content">
            我们的科学家团队来自谷歌、字节跳动、清华大学姚班的技术大拿组成，通过与资深人力资源领域专家队伍的强强联手，使赛码网在短短时间内就成为了在线考试/面试专业平台，并不断开发出更加贴合客户需求的人才甄选考试产品。
          </div>
        </div>
      </div>
      <div v-if="!isMobile" class="about-middle-down">
        <div class="about-middle-down-pic">
          <div class="content-left">
            <div class="inner">
              在线考试
              <div class="content-desc">
                智能一体化的系统平台为企业提供专业可靠的大规模在线考试解决方案
              </div>
            </div>
          </div>
          <div class="content-middle">
            <div class="inner">
              <div>提供产品</div>
              <div class="content-desc">
                我们为客户提供在线考试系统、<br />在线视频面试系统两大产品。<br />赛码广泛应用于校园招聘、社会招聘、<br />员工晋升考核、认证考核、知识竞赛、<br />高校招生测评等各种场景。
              </div>
            </div>
          </div>
          <div class="content-right">
            <div class="inner">
              在线面试
              <div class="content-desc">
                远隔万里能力依旧一目了然<br />
                距离不再遥远，人才近在眼前
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isMobile" class="about-middle-down-mobile">
        <div class="content-middle">
          <div class="inner">
            <div class="title">提供产品</div>
            <div class="content-desc">
              我们为客户提供在线考试系统、在线<br />视频面试系统两大产品。赛码广泛<br />应用于校园招聘、社会招聘、员工<br />晋升考核、认证考核、知识竞赛、<br />高校招生测评等各种场景。
            </div>
          </div>
        </div>
        <div class="flex">
          <div class="content-left">
            <div class="title">在线考试</div>
          </div>

          <div class="content-right">
            <div class="title">在线面试</div>
          </div>
        </div>
      </div>
    </div>
    <div class="about-bottom">
      <div class="about-bottom-pic">
        <div class="about-bottom-pic-content animated fadeInLeft slow">
          <div class="content-one">期待您加入我们</div>
          <div>创新、梦想、自由</div>
          <div>专业、敢拼</div>
          <div>从赛码开始</div>
          <a class="btn resumeTo" href="mailto:resume@acmcoder.com">投递简历</a>
        </div>
      </div>
      <div class="about-concat-box" id="concat-user">
        <concat-us />
      </div>
      <div v-if="!isMobile" class="about-bottom-pic-jb">
        <div class="bottom-pic-hd">发现有人考试作弊？立刻匿名举报！</div>
        <a class="btn" @click="onJubao"> 马上举报</a>
      </div>
      <footbox v-if="isMobile"></footbox>
    </div>
    <about-dialog
      v-if="aboutDialog"
      :dialogVisible="aboutDialog"
      @cancel="aboutDialog = false"
    />
  </div>
</template>

<script>
import AboutTopCell from '@/components/about/about-top-cell'
import AboutDialog from '@/components/about/about-dialog'
import ConcatUs from '@/components/about/concat-us'
import footbox from '@/components/product/interview/footer'
export default {
  data() {
    return {
      aboutDialog: false,
      isMobile: false,
    }
  },
  methods: {
    // 投递简历
    postResume() {},
  },
  components: {
    AboutTopCell,
    ConcatUs,
    AboutDialog,
    footbox,
  },
  mounted() {
    this.isMobile = this.$store.state.app.device
    this.toPage()
  },
  methods: {
    toPage() {
      let toPage = this.$route.query.to
      if (toPage) {
        window.scrollTo(0, document.getElementById(toPage).offsetTop)
      } else {
        window.scrollTo(0, 0)
      }
    },
    onJubao() {
      this.aboutDialog = true
      console.log(this.aboutDialog, 'add')
    },
  },
}
</script>

<style lang='scss' scoped>
.about {
  color: #333;
  .resumeTo {
    padding: 6px 20px;
    display: inline-block;
  }
  .about-top {
    height: 636px;
    width: 100%;
    padding: 50px 0;
    background: url('~@/static/images/about/about-top.jpg') no-repeat center top;
    text-align: center;
    color: #fff;
    font-weight: 340;
    font-size: 14px;
    letter-spacing: 1px;
    line-height: 25px;
  }
  .about-concat-box {
    background: #f7f8fd url('/static/images/bbg.png') repeat-x;
  }
  .about-middle {
    width: 100%;
    margin: auto;
    line-height: 24px;
    background: #f7f8fd url('/static/images/bbg.png') repeat-x;

    .about-middle-up {
      width: 1160px;
      margin: auto;
      display: flex;
      padding: 40px 15px;
      .about-middle-up-pic {
        flex: 1;
        height: 310px;
        background: url('~@/static/images/about/01.png') no-repeat center top;
      }
      .about-middle-up-content {
        border: 1px solid #dedede;
        flex: 1;
        font-size: 14px;
        padding: 70px 0 0 40px;
        .content-title {
          font-size: 24px;
          font-weight: 340;
          text-align: center;
          padding: 10px;
        }
        .content {
          padding-top: 30px;

          letter-spacing: 2px;
          line-height: 25px;
        }
      }
    }
    .about-middle-down {
      width: 100%;
      padding: 0px 0 40px;
      .about-middle-down-pic {
        height: 420px;
        width: 1140px;
        margin: auto;
        display: flex;
        font-size: 24px;
        color: #fff;
        text-align: center;
        .content-left {
          flex: 1;
          overflow: hidden;
          .inner {
            background: url('~@/static/images/about/02-1.png');
            background-size: cover;
            margin: auto;
            height: 100%;
            padding: 50% 0px;
            transition: all 0.3s;
            position: relative;
            &:hover {
              transform: scale(1.2, 1.2);
              .content-desc {
                display: block;
              }
            }
          }
          .content-desc {
            display: none;
          }
        }
        .content-middle {
          margin: auto;
          background: url('~@/static/images/about/02-2.png');
          background-size: cover;
          height: 100%;
          flex: 1;
          padding: 100px 0px;
        }
        .content-desc {
          padding: 40px;
          font-size: 14px;
          letter-spacing: 2px;
          line-height: 25px;
        }
        .content-right {
          flex: 1;
          overflow: hidden;
          .inner {
            background: url('~@/static/images/about/02-3.png');
            background-size: cover;
            margin: auto;
            height: 100%;
            padding: 50% 0px;
            transition: all 0.3s;
            position: relative;
            &:hover {
              transform: scale(1.2, 1.2);
              .content-desc {
                display: block;
              }
            }
          }
          .content-desc {
            display: none;
          }
        }
      }
    }
    .about-middle-down-mobile {
      color: #fff;
      font-weight: 340;
      text-align: center;
      .title {
        font-size: 24px;
        padding-top: 48%;
      }
      .content-middle {
        margin: auto;
        background: url('~@/static/images/about/02-2.png');
        background-size: cover;
        height: 400px;
        .title {
          padding-top: 32%;
        }
        .content-desc {
          padding: 20px;
          font-size: 16px;
          letter-spacing: 2px;
        }
      }
      .content-left {
        background: url('~@/static/images/about/02-1.png');
        background-size: cover;
        flex: 1;
        height: 200px;
      }
      .content-right {
        background: url('~@/static/images/about/02-3.png');
        background-size: cover;
        flex: 1;
        height: 200px;
      }
    }
  }
  .about-bottom {
    margin-top: -2px;
    .about-bottom-pic {
      background: url('https://cdnw2.acmcoder.com/release/www/2.0.1/images/QQ20220322-0.jpg?v=2') no-repeat center center;
      background-size: cover;
      width: 100%;
      height: 550px;
      font-size: 14px;
      text-align: center;
      color: #fff;
      .about-bottom-pic-content {
        width: 480px;
        height: 300px;
        margin-right: 30px;
        padding: 130px 0;

        div {
          padding: 6px;
        }
        .content-one {
          font-size: 24px;
          font-weight: 300;
          padding: 0 0 40px 0;
        }
        .btn {
          background-color: #fff;
          color: #29bdb9;

          margin-top: 60px;
        }
      }
    }
  }
  .about-bottom-pic-jb {
    background: url('~@/static/images/foot-top.png') no-repeat center bottom;
    width: 100%;
    height: 200px;
    font-size: 14px;
    text-align: center;
    color: #fff;
    .bottom-pic-hd {
      font-size: 24px;
      padding: 45px 0 30px 0;
      font-weight: 300;
    }
    .btn {
      margin: 10px 0 0;
    }
  }
}
@media screen and (max-width: 600px) {
  .about {
    .about-top {
      padding: 15px;
      height: initial;
      background-size: cover;
    }
    .about-middle {
      padding: 15px;
      display: block;
      .about-middle-up {
        width: initial;
        display: block;
        padding: 0px;
        .about-middle-up-pic {
          height: 175px;
          background-position-y: -60px;
        }
        .about-middle-up-content {
          padding: 20px;
          .content {
            padding: 10px 0px;
          }
        }
      }
    }
    .about-bottom {
      .about-bottom-pic {
        .about-bottom-pic-content {
          width: initial;
          padding-left: 25px;
        }
      }
    }
  }
}
@media screen and (min-width: 600px) and (max-width: 1024px) {
  .about {
    .about-top {
      padding: 15px;
      height: initial;
      background-size: cover;
    }
    .about-middle {
      padding: 15px;
      display: block;
      .about-middle-up {
        width: initial;
        display: block;
        padding: 0px;
        .about-middle-up-pic {
          height: 190px;
          background-position-y: -50px;
        }
        .about-middle-up-content {
          padding: 20px 40px;
          width: 600px;
          margin: auto;
          .content {
            padding: 10px 0px;
          }
        }
      }
      .about-middle-down-mobile {
        width: 600px;
        margin: auto;
        .content-middle {
          height: 600px;
        }
        .content-left,
        .content-right {
          height: 400px;
          .title {
            padding-top: 58%;
          }
        }
      }
    }
    .about-bottom {
      .about-bottom-pic {
        .about-bottom-pic-content {
          width: initial;
          padding-left: 25px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/about/index.vue